var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAddPlusOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7355 6.30547C7.30951 6.30547 8.5855 5.02948 8.5855 3.45547C8.5855 1.88146 7.30951 0.605469 5.7355 0.605469C4.16149 0.605469 2.8855 1.88146 2.8855 3.45547C2.8855 5.02948 4.16149 6.30547 5.7355 6.30547Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7587 8.01562C10.4439 8.01562 10.1887 8.27082 10.1887 8.58563V10.1888L8.58562 10.1888C8.27082 10.1888 8.01562 10.444 8.01562 10.7588V12.6113C8.01562 12.9261 8.27082 13.1813 8.58562 13.1813H10.1887V14.7844C10.1887 15.0992 10.4439 15.3544 10.7587 15.3544H12.6112C12.9261 15.3544 13.1812 15.0992 13.1812 14.7844V13.1813H14.7844C15.0992 13.1813 15.3544 12.9261 15.3544 12.6113V10.7588C15.3544 10.444 15.0992 10.1888 14.7844 10.1888L13.1812 10.1888V8.58562C13.1812 8.27082 12.9261 8.01562 12.6112 8.01562H10.7587Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30216 14.2839H0.605469L0.605469 13.6658C0.614544 12.7969 0.843703 11.9445 1.27154 11.1881C1.69938 10.4318 2.31193 9.79623 3.05199 9.34081C3.79205 8.88539 4.63547 8.62497 5.50346 8.58388C5.81659 8.56905 6.12923 8.58295 6.4376 8.62477",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAddPlusOutlined);
export default __webpack_public_path__ + "static/media/user-add-plus-outlined.9ca82b4fc25f45ba7aa81acb6d97ced2.svg";
export { ForwardRef as ReactComponent };